// util methods was copied from removed ChartGenerator.Utils (see rev. 41004)

export function getMaxScaleValue(maxValue, maxVerticalGridsCount) {
    var gapGenerator = _createGapGenerator();

    var maxScaleValue;
    while (true) {
        var gap = gapGenerator.next();
        var remain = maxValue % gap;
        var additive = gap; // additive for whole gap period
        if ((remain / gap) > 0.8) {
            additive = gap * 2;
        }
        maxScaleValue = (maxValue - maxValue % gap) + additive; // fill with full gap
        var calculatedGap = maxScaleValue / maxVerticalGridsCount;
        if (calculatedGap <= gap) {
            break;
        }
    }
    return maxScaleValue;
}

export function getMaxMinScaleValues(maxValue, minValue, maxVerticalGridsCount) {
    var maxScaleValue = 0;
    var minScaleValue = 0;
    var absMinValue = Math.abs(minValue);

    if (maxValue >= 0 && minValue >= 0) {
        maxScaleValue = getMaxScaleValue(maxValue, maxVerticalGridsCount);
    }
    else if (maxValue <= 0 && minValue <= 0) {
        minScaleValue = -getMaxScaleValue(absMinValue, maxVerticalGridsCount);
    }
    else {
        var gapGenerator = _createGapGenerator();
        var absMinScaleValue;

        mainCycle: while (true) {
            var gap = gapGenerator.next();
            var remainForMax = maxValue % gap;
            var remainForMin = absMinValue % gap;
            var additiveForMax = gap; // additive for whole gap period for max
            var additiveForMin = gap; // additive for whole gap period for min
            if ((remainForMax / gap) > 0.8) {
                additiveForMax = gap * 2;
            }
            if ((remainForMin / gap) > 0.8) {
                additiveForMin = gap * 2;
            }
            maxScaleValue = (maxValue - maxValue % gap) + additiveForMax;
            absMinScaleValue = (absMinValue - absMinValue % gap) + additiveForMin;

            var calculatedGapForMax;
            var calculatedGapForMin;
            for (var verticalGridsCount = 1; verticalGridsCount < maxVerticalGridsCount; verticalGridsCount++) {
                calculatedGapForMax = maxScaleValue / verticalGridsCount;
                calculatedGapForMin = absMinScaleValue / (maxVerticalGridsCount - verticalGridsCount);
                if (calculatedGapForMax <= gap && calculatedGapForMin <= gap) {
                    break mainCycle;
                }
            }
        }
        minScaleValue = -absMinScaleValue;
    }

    return {
        "maxScaleValue": maxScaleValue,
        "minScaleValue": minScaleValue
    }
}

/**
 * create gap sequence generator
 */
function _createGapGenerator() {
    var availableGaps = [1, 2, 5];
    var index = 0;
    return {
        "next": function() {
            var power = Math.ceil(index / availableGaps.length) - 1;
            if (power < 0) power = 0;
            return availableGaps[index++ % availableGaps.length] * Math.pow(10, power);
        }
    };
}

export function getVerticalGridCount(maxScaleValue, minScaleValue, maxVerticalGridCount) {
    if (maxScaleValue >= 0 && minScaleValue >= 0) {
        return Math.min(maxScaleValue, maxVerticalGridCount);
    }
    else if (maxScaleValue <= 0 && minScaleValue <= 0) {
        return Math.min(Math.abs(minScaleValue), maxVerticalGridCount);
    }
    else {
        return Math.min(maxScaleValue + Math.abs(minScaleValue), maxVerticalGridCount);
    }
}



// WEBPACK FOOTER //
// ./web/js/chart/utils.js